import CampaignPreview from './CampaignPreview';

export default CampaignPreview;
